/**
 * @Page ROM72
 * @Description [ROM72]납입지시 - 기초관리 - 단가변동현황
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import GridRibbon from "@/components/organisms/GridRibbon";
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import * as GridUtil from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
 import CommonUtil from '@/utils/CommonUtil'; 
 import Loading from "src/components/atoms/CustomLoading2";
  
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const Utils = new CommonUtil();
 
 
  function ROM72() {
 
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const userName = Common.getToken("name");
    const tVnt1 = '1' //Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const grdRom72Main = useRef();   //Grid Main
    let [loading, setLoading] = useState(false); 
    const [panded, setPanded] = React.useState(true);
    // const [style, setStyle] = useState({ height :"calc(100vh - 60px - 50px - 100px  - 50px)"});
    //   const [style, setStyle] = useState({ height: "calc(100vh - 65px - 35px - 50px - 21px - 101px )" });
      const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"});
      
    //Data
    const [idata, setData] = useState({
        //조회조건
        kComp : tComp,      //회사구분
        kPtno : "",         //품번
        kPlnt: "",          //공장
        kDanga : "N",       //최종단가
        kVnt1Nm : "",        //T1업체명
        kCompNm : tComp==="EHMC"?"현대자동차(주)":"기아자동차(주)",        //회사명

        //코드 데이터
        plntList : [],  //공장
        compList : [],  //회사
    }); 
    
         
    const [message, setMessage] = React.useState( {
        openAlert : false,      
        severity : "success",   
        msg : ""                
    });
    const { openAlert, severity, msg } = message;
  
  
    //Dialog
    const [dlgMessage, setDlgMessage] = React.useState( {
        openDlg : false,    
        dlgTrans : "",      // Dialog Transaction(I,U,D)
        dlgMsg : ""         
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
  
   
    //Grid Search, Insert, Update, Delete Api
    let [searchApi, setSearchApi] = useState(false); 
    
    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);

    }, []);


    /**
     * 공통코드 조회 (조회조건)
     */
    const onSearchCommon = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                        commonData[name] = data.data

                        if (name === "plntList") {
                            if (data.data.length > 0 ) {
                                commonData["kPlnt"] = data.data[0].comCode
                                commonData["kPlntNm"]=data.data[0].text;
                            }
                        }
                        setData({...commonData});
                    }
                })
        }
        fetchData(para, name);
    }
     
    /**
         * 회사구분
         * @param {*} para 
         * @param {*} name 
         */
    const onSearchCommon1 = (para, name) => {
        let commonData = idata;

        const fetchData1 = async (para, name) => {

            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search1?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    {
                        if (name === "compList") {

                        }
                        commonData[name] = data.data
                        setData({...commonData});
                    }
                })
        }
        fetchData1(para, name);
    }

    /**
     *MOUNT 
    */
    useEffect( () => {

        //공통코드 조회 (공장)
        onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${tVnt1}","kComp":"${idata.kComp}"}`, "plntList");

        //공통코드 조회 (회사구분)
        onSearchCommon1(`{"pgmid":"CODE", "vand":"****", "gocd":"COMP","order":"COMP"}`, "compList");

    }, []);
  
  
  
    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value, desc} = e.target;

        let newSearchs = idata; 
        newSearchs[name] = value;
        newSearchs[name+"Nm"] = desc;
        setData({ ...newSearchs });

         // 회사구분 변경시 
         if (name === "kComp")  {
            
            newSearchs["plntList"] = [];
            setData({ ...newSearchs });

            //공통코드 조회 (공장)
            onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${tVnt1}","kComp":"${idata.kComp}"}`, "plntList");
        }
    }
 
  
  
    /**
     * Grid Event 
     * @param {*} e 
     */
    const grdRom72Main_onCellValueChanged = async (e) => {
    }
    const grdRom72Main_onRowClicked = async (e) => {
    }


  
  
    /**
     * 검색조건
     */
    const optionsX = {
        0: [
            //회사구분
            {
                "formatter": "select", "name": "kComp", "labelName": "회사구분", "type": "text", "defaultValue": idata.kComp,  
                "codeMode": true,
                "selectAll": "",
                "codes": idata.compList,
                "comms": null,
                "align": "left", 
            }, 
            //품번
            {
                "formatter": "input", "name": "kPtno", "labelName": "품번", "type": "text", "desc": "", "readOnly" : false,
                "defaultValue": idata.kPtno,  
                "align": "left", 
                "labelType": "none", 
            }, 
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ],
        1: [
            //공장
            {
                "formatter": "select", "name": "kPlnt", "labelName": "공장", "type": "text", "defaultValue": idata.kPlnt,  
                "codeMode": false,
                "selectAll": "",
                "codes": null,
                "comms": idata.plntList,
            }, 
             //최종단가
                 
            {
                "formatter": "checkSpan", "name": "kDanga", "labelName": " ",
                "options": [{ "name": "kDanga", "labelName": "최종단가", "defaultValue": idata.kDanga }] 
            },

            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ],
        
    }
  
  
  
    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {
        //회사구분선택 Check
        if (idata.kComp == "")
        {
            setMessage({ openAlert : true, 
                         severity : "info",
                         msg : "회사구분을 선택하십시요 !"});
            document.getElementById("kComp").focus();                         
            return ;
        }

         //공장선택 Check
         if (idata.kPlnt == "")
         {
             setMessage({ openAlert : true, 
                          severity : "info",
                          msg : "공장을 선택하십시요 !"});
             document.getElementById("kPlnt").focus();                         
             return ;
         }
        
        let para = `{"kComp":"${idata.kComp}","kPtno":"${idata.kPtno}", "kPlnt":"${idata.kPlnt}" , "kDanga":"${idata.kDanga}"}`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/rom72/search?query=" + param;
        setSearchApi(query); // Search API
    }

  
  
    /**
     * 신규 Row추가
     * @param {*} e 
     */
    const onAddRow = async (e) => {
    }

  
      
    /**
     * 입력 (발행)
     * @param {*} e 
     */
    const onInsert = async (e) => {
    }
  
  
  
    /**
     * 수정 
     * @param {*} e 
     * @returns 
     */
    const onUpdate = async (e) => {
    }


  
    /**
     * 삭제
     * @param {*} e 
     */
    const onDelete = async (e) => {
    }



    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        let para = `{"kComp":"${idata.kComp}","kPtno":"${idata.kPtno}", "kPlnt":"${idata.kPlnt}" , "kDanga":"${idata.kDanga}",
                     "compNm":"${idata.kCompNm}","plntNm":"${idata.kPlntNm}"
                    }`;
        let param = encodeURI(para);
        const query = SERVER_URL + "/rom72/excel?query=" + param;

        //엑셀파일 조회 시 로딩오픈
        setLoading(true);
    

        await fetch(query, {headers: {Authorization: token } })
            .then((resp) =>{
                return resp.blob();
            }).then((blob)=>{
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', 'rom72.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })

        //엑셀파일 조회 시 로딩 닫기

        setLoading(false);
        
        // 엑셀파일 생성 메세지
        setMessage({ openAlert : true, 
                     severity : "success",
                     msg : "엑셀파일이 생성되었습니다."});
    }


    
    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});


        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) 
        {
            //등록
            case "I" :
                break;
            //수정
            case "U" :
                break;
            //삭제
            case "D" :
                break;

            case "D3" :
                break;
        }
    }

    

    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
              });
        }else{
            setStyle({
                height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"
              });
        }
    }
  
    /**
     *Grid Column 정의 
    */
    //Main Grid Column
    const columnDefs = [  
        { headerName: "품번", field: "ptno", sortable: true, filter: true, flex: 0, minWidth: 420, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, valueGetter: Utils.partnoGetter, hide: false },
        { headerName: "품명", field: "ptnm", sortable: true, filter: true, flex: 0, minWidth: 550, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: false },
        { headerName: "변경일자", field: "crdt", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false, valueFormatter: Utils.dateFormatter }, 
        { headerName: "단가", field: "igpr", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, valueFormatter: Utils.numberFormatterFixed2, hide: false}, 
    ];

  
      
    return(
        <>
            {/* Dialog FRAME */}
            <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* Alert FRAME */}
            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
            
            {/* Loading */}
            <Loading loading={loading} /> 
                    
            {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
            <Ribbon
                onSearch={onSearch} onSearchName={null} //조회
                onExcel={onExcel} onExcelName ={null}   //Excel
            >
                {"납입지시 > 기초관리 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>단가변동현황</b>
            </Ribbon>


            {/* ContentXearch Frame : 검색조건 */}
            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick = {onClick} />


            {/* Content FRAME (Data / Grid Frame) START -------------- */}
            <Content style={style}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:100px */}
                <div className={"grid_type01"} > {/* 상단 FRAME */}
                    <div className={"grid_wrap01"}> {/* 상단 wrap FRAME */}
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdRom72Main}
                                gridId={"ROM72"}                    //  (필수) Grid Id 정의
                                columnDefs={columnDefs}             //  (필수) 컬럼 정의 
                                pagination={true}                  //  쪽수 매기기 여부
                                paginationCsv={false}                //  CSV 사용구분 - pagination과 동시에 사용 필요
                                paginationPageSize={"1000"}         //  쪽수 1Page 당 Row수
                                rowMultiSelectWithClick={true}      //  멀티 클릭 가능 여부
                                suppressRowClickSelection={true}    //  클릭으로 선택 하는것을 방지
                                rowSelection={"multiple"}           //  여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
                                enableRangeSelection={false}        //  
                                enableCellTextSelection={true}      // cell selection drag mode
                                isFirst={false}                      // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
                                displayNo = {false}
                                searchApi={searchApi}               // 조회
                                onClearApi={onClearApi}
                                //onClearApi={()=> {onSetCount();onClearApi()}}
                                onCellValueChangedEvent={grdRom72Main_onCellValueChanged}
                                onRowClickEvent={grdRom72Main_onRowClicked}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
  }
  export default ROM72;